module.exports = __webpack_public_path__ + "img/bingo-base.481f96ef.png";